import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiGrid,
  FiList,
  FiDollarSign,
  FiPackage,
  FiRotateCcw,
  FiCreditCard,
  FiBarChart2,
  FiTrendingUp,
  FiDownload
} from 'react-icons/fi';

const Reportes = () => {
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState('grid');
  const [searchQuery, setSearchQuery] = useState('');

  // Tipos de reportes disponibles
  const reportes = [
    {
      id: 'ventas',
      tipo: 'VENTAS',
      nombre: 'Reporte de Ventas',
      descripcion: 'Análisis detallado de ventas por período',
      icon: FiDollarSign,
      gradient: 'blue-dark-gradient',
      metricas: {
        total: '$125,450.00',
        descripcion: 'Mes actual'
      }
    },
    {
      id: 'inventario',
      tipo: 'INVENTARIO',
      nombre: 'Reporte de Inventario',
      descripcion: 'Estado actual del inventario y movimientos',
      icon: FiPackage,
      gradient: 'green-gradient',
      metricas: {
        total: '1,245',
        descripcion: 'Productos en stock'
      }
    },
    {
      id: 'retorno',
      tipo: 'RETORNO',
      nombre: 'Reporte de Retornos',
      descripcion: 'Seguimiento de devoluciones y retornos',
      icon: FiRotateCcw,
      gradient: 'orange-gradient',
      metricas: {
        total: '18',
        descripcion: 'Retornos este mes'
      }
    },
    {
      id: 'creditos',
      tipo: 'CRÉDITOS',
      nombre: 'Reporte de Créditos',
      descripcion: 'Análisis de ventas a crédito y cartera',
      icon: FiCreditCard,
      gradient: 'purple-gradient',
      metricas: {
        total: '$45,200.00',
        descripcion: 'Por cobrar'
      }
    }
  ];

  const handleReporteClick = (reporteId) => {
    navigate(`/system/reportes/${reporteId}`);
  };

  const handleDownload = () => {
    console.log('Descargar reportes');
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredReportes = reportes.filter(reporte =>
    reporte.nombre.toLowerCase().includes(searchQuery.toLowerCase()) ||
    reporte.descripcion.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="formulaciones-page">
      {/* Título */}
      <h1 className="page-title">REPORTES Y ANÁLISIS</h1>

      {/* Menú de acciones */}
      <div className="page-header-with-menu">
        <div className="action-menu">
          <div className="menu-item menu-item--search">
            <label className="search-label">BUSCAR:</label>
            <input
              type="text"
              className="search-input"
              placeholder="BUSCAR REPORTE"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>

          <button className="menu-item menu-item--download" onClick={handleDownload}>
            DESCARGAR TODOS ↓
          </button>

          <div className="menu-item menu-item--views">
            <button
              className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => setViewMode('grid')}
            >
              <FiGrid />
            </button>
            <button
              className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => setViewMode('list')}
            >
              <FiList />
            </button>
            <button className="view-btn">
              ○
            </button>
          </div>
        </div>
      </div>

      {/* Contenido */}
      {filteredReportes.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">
            <FiBarChart2 size={48} />
          </div>
          <h3 className="empty-state-title">No se encontraron reportes</h3>
          <p className="empty-state-description">
            No se encontraron reportes que coincidan con "{searchQuery}"
          </p>
          <p>
            <button
              className="btn btn--ghost"
              onClick={() => setSearchQuery('')}
            >
              Limpiar búsqueda
            </button>
          </p>
        </div>
      ) : (
        <div className={viewMode === 'grid' ? 'content-grid' : 'content-list'}>
          {filteredReportes.map((reporte) => {
            const IconComponent = reporte.icon;

            return (
              <div
                key={reporte.id}
                className={viewMode === 'grid' ? 'content-card' : 'content-card-list'}
                onClick={() => handleReporteClick(reporte.id)}
                style={{ cursor: 'pointer' }}
              >
                {viewMode === 'grid' ? (
                  <>
                    <div className={`content-thumbnail ${reporte.gradient}`}>
                      <div className="formula-icon">
                        <IconComponent size={32} />
                      </div>
                      <div className="status-badge status-badge--info">
                        <FiTrendingUp /> Activo
                      </div>
                    </div>
                    <div className="content-info">
                      <div className="content-title">{reporte.nombre}</div>
                      <div className="content-subtitle">{reporte.descripcion}</div>
                      <div className="content-meta">
                        <span className="meta-item">
                          <strong>{reporte.metricas.total}</strong>
                        </span>
                        <span className="meta-item">
                          {reporte.metricas.descripcion}
                        </span>
                      </div>
                    </div>
                    <div className="content-card__actions">
                      <FiBarChart2 className="card-icon" />
                    </div>
                  </>
                ) : (
                  <>
                    <div className={`content-thumbnail-small ${reporte.gradient}`}>
                      <IconComponent size={20} />
                    </div>
                    <div className="content-info-list">
                      <div className="content-title">{reporte.nombre}</div>
                      <div className="content-subtitle">{reporte.descripcion}</div>
                      <div className="content-meta">
                        <span className="meta-item">
                          <strong>{reporte.metricas.total}</strong> - {reporte.metricas.descripcion}
                        </span>
                        <span className="meta-item">
                          <FiTrendingUp size={12} /> Activo
                        </span>
                      </div>
                    </div>
                    <div className="content-actions-list">
                      <FiBarChart2 className="card-icon" />
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Reportes;
